import React, { useState } from 'react';
import { IConversationEnriched } from '@eagerdog/interfaces';
import styles from './Messages.module.scss';

interface IProps {
  conversations: IConversationEnriched[];
  activeId: string | null;
  onSelect: (conv: IConversationEnriched) => void;
}

const getInitials = (name: string): string => {
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ConversationList: React.FC<IProps> = ({ conversations, activeId, onSelect }) => {
  const [search, setSearch] = useState('');

  const filtered = search.trim()
    ? conversations.filter((c) =>
        c.other_user.display_name.toLowerCase().includes(search.toLowerCase()),
      )
    : conversations;

  return (
    <div className={styles.conversationList}>
      <div className={styles.searchWrap}>
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className={styles.convListScroll}>
        {filtered.length === 0 && (
          <div className={styles.emptyList}>
            {search ? 'No results' : 'No conversations yet'}
          </div>
        )}
        {filtered.map((conv) => (
          <div
            key={conv._id}
            className={`${styles.convItem} ${conv._id === activeId ? styles.active : ''}`}
            onClick={() => onSelect(conv)}
          >
            <div className={styles.convAvatar}>
              {conv.other_user.logo_url ? (
                <img
                  src={conv.other_user.logo_url}
                  alt={conv.other_user.display_name}
                  className={styles.convAvatarImg}
                />
              ) : (
                getInitials(conv.other_user.display_name)
              )}
            </div>
            <div className={styles.convInfo}>
              <div className={styles.convName}>{conv.other_user.display_name}</div>
              {conv.last_message_preview && (
                <div className={styles.convPreview}>{conv.last_message_preview}</div>
              )}
            </div>
            {conv.unread_count > 0 && (
              <div className={styles.convUnread}>
                {conv.unread_count > 99 ? '99+' : conv.unread_count}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConversationList;
